import Service, { service } from '@ember/service'
import { task } from 'ember-concurrency'
import type Store from '@ember-data/store'
import type SessionService from 'teacher-ui-client/services/session'
import type FeaturesService from 'teacher-ui-client/services/features'
import { contentVariant } from 'teacher-ui-client/utils/content-variant'
import {
  buildPrimaryFilters,
  readingAgePrimaryFilter,
  fastPhonicsPrimaryFilter,
  localisePrimaryFilters,
} from 'teacher-ui-client/reading-scales/utils'
import type BookLibraryReadingScale from 'teacher-ui-client/models/book-library/reading-scale'

export default class ReadingScalesService extends Service {
  @service features!: FeaturesService
  @service session!: SessionService
  @service store!: Store

  get libraryAccent() {
    // While normally a school will always have an accent, the optional chaining here is relied upon by a lot of tests
    return contentVariant(this.session.currentSchool?.accent?.extension ?? 'au')
  }

  allPrimaryFilters = task({ restartable: true }, async () => {
    const scales = await this.store.query<BookLibraryReadingScale>('book-library/reading-scale', {})
    let primaryFilters = [...buildPrimaryFilters(scales), readingAgePrimaryFilter]
    if (this.features.isEnabled('tui_fp_teacher_library_filter')) {
      primaryFilters = [...primaryFilters, fastPhonicsPrimaryFilter]
    }
    return localisePrimaryFilters(primaryFilters, this.libraryAccent)
  })
}

declare module '@ember/service' {
  interface Registry {
    'reading-scales': ReadingScalesService
  }
}
